import React from "react";
import '../App.css';

function Download () {
    return ( 
    <>
    <h1 className="download">Download the app</h1>
    </>
    );
}

export default Download;